<template>
  <div class="pc-container">
    <div class="header">
      <div class="header-box">
        <div class="header-logo">
          <img src="../assets/pc/logo.png">
        </div>
        <div class="header-li-box">
          <div class="header-li" @click="goToWhere('/home')"><span>首页</span></div>
          <div class="header-li">
            <span>产品介绍</span>
            <div class="li-active"></div>
          </div>
          <div class="header-li" @click="goToWhere('/banner')"><span>下载APP</span></div>
          <div class="header-li" @click="goToWhere('/secret')"><span>隐私政策</span></div>
        </div>
      </div>
    </div>
    <div class="content">
      <div class="banner-box">
        <div class="banner-text">
          <div class="text-title">麻城掌上公交</div>
          <div class="text-content">
            ——— ——— 功能全面、操作简便的公交出行服务软件。作为智慧城市的一部分，通过结合GPS实时定位、移动互联网、智能公交等先进技术，旨在为乘客提供更为便捷、优质高效的出行体验。
          </div>
          <div class="banner-phone">
            <img src="../assets/pc/banner_phone.png">
          </div>
        </div>
      </div>
      <div class="content-box">
        <div class="content-li">
          <div class="cl-img">
            <img src="../assets/pc/car.png">
          </div>
          <div>区域公交查询</div>
        </div>
        <div class="content-li">
          <div class="cl-img">
            <img src="../assets/pc/route_plan.png">
          </div>
          <div>线路查询</div>
        </div>
        <div class="content-li">
          <div class="cl-img">
            <img src="../assets/pc/real_bus.png">
          </div>
          <div>公交动态实时查询</div>
        </div>
        <div class="content-li">
          <div class="cl-img">
            <img src="../assets/pc/location.png">
          </div>
          <div>公交实时地图</div>
        </div>
        <div class="content-li">
          <div class="cl-img">
            <img src="../assets/pc/lost_found.png">
          </div>
          <div>失物招领</div>
        </div>
      </div>
    </div>
    <div class="footer">
      <div class="footer-box">
        <div class="footer-li">
          <div class="fl-text">COPYRIGHT 2023-2024 湖北麻城宇通公交公司</div>
          <div>
            <div><img src="../assets/pc/national.png"><span class="fl-nationl">鄂ICP备2024067966号</span></div>
          </div>
        </div>
        <div class="footer-li">
          <img class="fl-p-img" src="../assets/pc/phone.png">
          <span class="fl-phone">0713-2950303</span>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  methods: {
    goToWhere(flag) {
      this.$router.push(flag);
    }
  }

}
</script>

<style lang="scss" scoped>
//如果个别地方不想转化px。可以简单的使用大写的 PX 或 Px
.pc-container {
  width: 100%;
  height: 100%;
  background-color: #fff;

  .header {
    height: 110PX;

    .header-box {
      margin: 0 360PX;
      height: 100%;
      display: flex;

      .header-logo {
        margin: 27PX 0;
      }

      .header-li-box {
        margin-left: 250PX;
        display: flex;
        align-items: center;
        font-size: 16PX;

        .header-li {
          text-align: center;
          padding: 42PX 30PX;
          position: relative;
          cursor: pointer;
        }

        .li-active {
          border-bottom: 4PX solid #61ADBE;
          bottom: 0;
          left: 0;
          width: 100%;
          position: absolute;
        }
      }
    }
  }

  .content {
    .banner-box {
      width: 100%;
      height: 404PX;
      background: linear-gradient(0deg, #004C9D 0%, #008BAA 100%);

      .banner-text {
        padding: 80PX 0;
        color: #fff;
        margin: 0 360PX;
        position: relative;


        .text-title {
          font-size: 50PX;
          margin-bottom: 30PX;
        }

        .text-content {
          font-size: 18PX;
          line-height: 32PX;
          width: 503PX;
        }

        .banner-phone {
          position: absolute;
          top: 17PX;
          right: 0;
          width: 540PX;

          img {
            width: 100%;
            height: 100%;
          }
        }
      }


    }

    .content-box {
      margin: 0 360PX;
      height: 319PX;
      font-size: 18PX;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .content-li {
        display: flex;
        flex-direction: column;
        align-items: center;

        .cl-img {
          margin-bottom: 5PX;
        }
      }
    }
  }

  .footer {
    height: 86PX;
    background: #003265;

    .footer-box {
      margin: 0 360PX;
      height: 100%;
      display: flex;
      justify-content: space-between;
      align-items: center;

      .footer-li {
        display: flex;

        .fl-text {
          color: #fff;
          font-size: 14PX;
          margin-right: 10PX;
        }

        .fl-nationl {
          color: #878787;
          font-weight: bolder;
          margin-left: 5PX;
        }

        .fl-p-img {
          width: 16PX;
          height: 18PX;
        }

        .fl-phone {
          font-size: 18PX;
          color: #61ADBE;
          margin-left: 5PX;
        }
      }
    }
  }
}
</style>